import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import Gear from '../../partials/gear';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';
import { getBase64, } from '../../../helpers';
import request from 'superagent';
import config from '../../../config';
import { Popover, PopoverBody, PopoverHeader, } from 'reactstrap';

class AddAlumni extends React.Component {
    state = {
        alumni: null,
        microTransac: false,
        deleting: false
    }
    componentWillMount() {
        const { alumnis = [], alumniActions, params } = this.props, { id } = params;
        if (id) {
            if (alumnis && alumnis.length && _.find(alumnis, a => parseInt(a.id, 10) === parseInt(id, 10))) {
                this.setState({ alumni: _.find(alumnis, a => parseInt(a.id, 10) === parseInt(id, 10)) })
            } else {
                this.setState({ microTransac: true }, () => { alumniActions && alumniActions.fetch(id); });
            }
        } else {
            this.setState({ alumni: {} });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { alumni } = nextProps;
        this.setState({ alumni, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => { this.props.router.push('/admin'); });
    }
    handleAvatar = e => {
        const { alumni } = this.state;
        getBase64(e.target.files[0]).then(data => {
            alumni.Image = data;
            this.setState({ alumni });
        });
    }
    save = () => {
        const { alumni } = this.state, { alumniActions } = this.props;
        alumni.Name = this.txtName.value;
        alumni.NationalsYear = this.txtNationalsYear.value;
        alumni.Team = this.txtTeam.value;
        alumni.BestFinish = this.txtBestFinish.value;
        alumni.College = this.txtCollege.value;
        alumni.Professional = this.txtProfessional.value;
        alumni.Testimony = this.txtTestimony.value;
        alumni.Url = this.txtUrl.value;
        alumni.Sort = this.txtSort.value;

        this.setState({ microTransac: true }, () => {
            request[alumni.id ? 'patch' : 'post'](`${config.apiEndpoint}/v2/alumni${alumni.id ? `/${alumni.id}` : ''}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .send(alumni)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        alumniActions.fetch();
                        this.props.router.push('/admin/alumni');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    doDelete = () => {
        const { alumni } = this.state, { alumniActions } = this.props;
        this.setState({ microTransac: true }, () => {

            request.del(`${config.apiEndpoint}/api/cs/v2/alumnis/${alumni.id}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        alumniActions.fetch();
                        this.props.router.push('/admin/alumni');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    render() {
        const { alumni = {}, microTransac } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/alumnis" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">ALUMNI | ADD</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={7} onLogout={this.logout} animated={false} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix padding-right">
                        {alumni &&
                            <ScrollAnimation animateIn="fadeInRight" animateOnce={true}>
                                <figure className="card w-100 p-4 bg-black">
                                    <label htmlFor="name" className="white">Alumni Name</label>
                                    <input className="" type="text" required ref={(i) => this.txtName = i} defaultValue={alumni.Name} />
                                    <label htmlFor="name" className="white">Nationals Year</label>
                                    <input className="" type="text" required ref={(i) => this.txtNationalsYear = i} defaultValue={alumni.NationalsYear} />
                                    <label htmlFor="name" className="white">Team</label>
                                    <input className="" type="text" required ref={(i) => this.txtTeam = i} defaultValue={alumni.Team} />
                                    <label htmlFor="name" className="white">Best Finish</label>
                                    <input className="" type="text" required ref={(i) => this.txtBestFinish = i} defaultValue={alumni.BestFinish} />
                                    <label htmlFor="name" className="white">College</label>
                                    <input className="" type="text" required ref={(i) => this.txtCollege = i} defaultValue={alumni.College} />
                                    <label htmlFor="name" className="white">Professional</label>
                                    <input className="" type="text" required ref={(i) => this.txtProfessional = i} defaultValue={alumni.Professional} />
                                    <label htmlFor="name" className="white">Testimony</label>
                                    <input className="" type="text" required ref={(i) => this.txtTestimony = i} defaultValue={alumni.Testimony} />
                                    <label htmlFor="name" className="white">Personal Page Link</label>
                                    <input className="" type="text" required ref={(i) => this.txtUrl = i} defaultValue={alumni.Url} />
                                    <label htmlFor="name" className="white">Sort</label>
                                    <input className="" type="text" required ref={(i) => this.txtSort = i} defaultValue={alumni.Sort} />

                                    <div className="car w-100 p-4 d-flex flex-column justify-content-center pointer">
                                        <input type="file" id="fi" onChange={this.handleAvatar} className="hide" ref={i => this.avatarFU = i} />
                                        <label htmlFor="fi" className="d-flex flex-column justify-content-center h-100">
                                            {!alumni.Image && <i className='fas fa-plus font-50 align-self-center green' />}
                                            {alumni.Image && <img alt="" style={{ height: 100 }} src={alumni.Image} className="align-self-center" />}
                                            <span className="margin-top-half align-self-center white">{alumni.Image ? 'Change' : 'Add'}{' '}Picture</span>
                                        </label>
                                    </div>
                                    <div className="d-flex flex-row">
                                        {alumni.id && <button id="btn-delete" onClick={this.toggleDelete} type="button" style={{ width: 100 }} className="align-self-center btn-red text-center">REMOVE</button>}
                                        <Link to="/admin/alumnis" className="align-self-center btn-link text-center ml-auto margin-right white">CANCEL</Link>
                                        <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-black text-center">SAVE</button>
                                    </div>
                                    {alumni.id && <Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete`} toggle={this.toggleDelete}>
                                        <PopoverHeader>Are you sure?</PopoverHeader>
                                        <PopoverBody className="d-flex flex-row justify-content-center">
                                            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
                                            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
                                        </PopoverBody>
                                    </Popover>}
                                </figure>
                            </ScrollAnimation>}
                    </section>
                </div>
            </section>
        )
    }
}

export default AddAlumni;



// WEBPACK FOOTER //
// ./src/components/private/alumni/add.js